module.exports = __webpack_public_path__ + "img/jiQiRen6.3702f022.png";